import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbNotificationModule } from 'mdb-angular-ui-kit/notification';
import { DefaultToastComponent } from './mdb-toast/default-toast/default-toast.component';
import { SuccessToastComponent } from './mdb-toast/success-toast/success-toast.component';
import { WarningToastComponent } from './mdb-toast/warning-toast/warning-toast.component';
import { DangerToastComponent } from './mdb-toast/danger-toast/danger-toast.component';
import { ToastMdbComponent } from './mdb-toast/toast/toast.component';


@NgModule({
  declarations: [DefaultToastComponent, SuccessToastComponent, WarningToastComponent, DangerToastComponent, ToastMdbComponent],
  imports: [
    CommonModule,
    MdbNotificationModule
  ],
  exports: [DefaultToastComponent, SuccessToastComponent, WarningToastComponent, DangerToastComponent, ToastMdbComponent]
})
export class ToastModule {
  constructor() {}
}
